// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { SlideReveal } from '@src/components/SlideReveal/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const SecondhandDouble: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Secondhand Expected to Double Market Share in 10 Years
      </h1>
      <h2
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="mb-8"
      >
        Meet the closet of the future.
      </h2>

      <SlideReveal>
        <Image
          {...DEFAULT_SAL_PROPS}
          alt="Closet Chart"
          fileName="3b-closet-chart.png"
        />
      </SlideReveal>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 2}
        className="tup-source text-center mt-12"
      >
        GlobalData Market Sizing and Growth Estimates
      </p>
    </div>
  );
};

export { SecondhandDouble };
